import axios from 'axios';

const loadItems = (options, obj) => {
  if (!obj) {
    obj = {
      page: 'all',
      search: '',
    };
  }

  axios.get('/crm/employees/', {
    params: obj,
  }).then(response => {
    options.commit('SET_ITEMS', response.data);
  });
};

const loadActive = options => {
  if (options.state.active.length > 0) {
    return;
  }

  axios.get('/crm/employees/active').then(response => {
    options.commit('SET_ACTIVE', response.data.data);
  });
};

const loadPermissions = options => {
  axios.get('/accounts/permissions/').then(response => {
    options.commit('SET_PERMISSIONS', response.data.permissions);
  });
};

const addItem = (options, obj) => {
  let bodyFormData = new FormData();

  if (obj.photo) {
    bodyFormData.append('photo', obj.photo);
    delete obj.photo;
  }

  bodyFormData.append('obj', JSON.stringify(obj));
  axios.post('/crm/employees/create/', bodyFormData)
    .then(response => {
      options.commit('ADD_ITEM', response.data);
      if (response.data.status === 900 || response.data.status === 901) {
        options.commit('SET_ERROR_MESSAGE', { title: 'Houve um erro', message: response.data.message }, { root: true });
        setTimeout(() => {
          location.reload()
        }, 1000);
      }
    });
};

const editItem = (options, obj) => {
  let bodyFormData = new FormData();

  if (obj.photo) {
    bodyFormData.append('photo', obj.photo);
    delete obj.photo;
  }

  bodyFormData.append('obj', JSON.stringify(obj));
  axios.post('/crm/employees/' + obj.pk + '/update/', bodyFormData)
    .then(response => {
      options.commit('EDIT_ITEM', response.data);
    });
};

const deleteItem = (options, obj) => {
  axios.post('/crm/employees/' + obj.pk + '/delete/', obj)
    .then(() => {
      options.commit('DELETE_ITEM', obj);
    });
};

const updatePermissions = (options, obj) => {
  return axios.post('/crm/employees/' + obj.pk + '/update_permissions/', {
    permission_codes: obj.permissionCodes,
  })
    .then(() => {
      options.commit('UPDATE_PERMISSIONS', obj);
    });
};

const addVacation = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('obj', JSON.stringify(obj));
  return axios.post('/crm/employees/vacation/add/', bodyFormData)
  .then(response => {
    return response.data
  })
}

const updateVacation = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('obj', JSON.stringify(obj));
  return axios.post('/crm/employees/vacation/' + obj.vacationPk + '/update/', bodyFormData)
  .then(response => {
    return response.data
  })  
}

const deleteVacation = (options, vacationPk) => {
  return axios.post('/crm/employees/vacation/' + vacationPk + '/delete/')
  .then(response => {
    return response.data
  }) 
}

export default {
  loadItems,
  addItem,
  editItem,
  deleteItem,
  loadPermissions,
  loadActive,
  updatePermissions,
  addVacation,
  updateVacation,
  deleteVacation,
};
